export default class KliraCartItem {
    uid = null;
    quantity = 0;
    product = null;
    additionalFields = null;
    journeyMap = {
        201: {
            label: "OILY & HYPERPIGMENTED SKINSIZES",
            image: "https://stg-api.klira.skin/uploads/69dc64b9a2fa561784a39c375877fa69d2e18f86_1_e21d222d8f.png"
        },
        202: {
            label: "OILY & NON-HYPERPIGMENTED SKINSIZES",
            image: "https://stg-api.klira.skin/uploads/oily_and_nonhyperpigmented_68fac3cabc.png"
        },
        203: {
            label: "DRY & HYPERPIGMENTED SKINSIZES",
            image: "https://stg-api.klira.skin/uploads/dry_and_hyperpigmented_4a5e5a1e4c.png"
        },
        204: {
            label: "DRY & NON-HYPERPIGMENTED SKINSIZES",
            image: "https://stg-api.klira.skin/uploads/dry_and_nonhyperpigmented_6b508602e1.png"
        }
    };

    constructor(product, quantity, additionalFields) {
        this.uid = Math.random().toString(16).slice(2);
        // Product should be a KliraProduct (see products.js)
        this.product = product;
        this.quantity = quantity;
        this.additionalFields = additionalFields;
        if (product.isDayScript) {
            const journey_id = additionalFields.journey_id;

            this.additionalFields = {
                journey_id: journey_id || null,
                journey_label: journey_id ? this.journeyMap[journey_id]?.label || null : null,
                journey_image: journey_id ? this.journeyMap[journey_id]?.image || null : null,
            };
        } else {
            this.additionalFields = additionalFields;
        }
    }

    getQuantity() {
        return this.quantity;
    }

    getProduct() {
        return this.product;
    }

    getTotalPrice() {
        return this.getProduct().price * this.getQuantity();
    }

    getAdditionalFields() {
        return this.additionalFields;
    }
}